import { useState, useEffect } from 'react'

export function WithClient({
  children,
  fallback,
}: {
  children: React.ReactElement
  fallback?: () => React.ReactElement | null
}) {
  const [isClient, setIsClient] = useState(false)

  useEffect(() => {
    setIsClient(true)
  }, [])

  if (!isClient) {
    return fallback ? fallback() : null
  }

  return children
}
